import { parse, format, isToday, isThisYear, differenceInYears } from 'date-fns';
import { ru } from 'date-fns/locale';

export default {
  install: app => {
    app.config.globalProperties.$dates = {
      parse,
      format: (date, template) => format(date, template, { locale: ru }),
      isToday,
      isThisYear,
      differenceInYears
    };
  }
};
